import { defineStore } from 'pinia';

export const useMessageStore = defineStore({
    id: "message",
    state: () => ({
        messageControl: {
            message: '',
            show: false,
            type: '', // e.g., 'error', 'success', 'warning', etc.
        }
    }),


    showMessage(message, type = '') {
        this.messageControl = { message, show: true, type };
    },

    hideMessage() {
        this.messageControl.show = false;
    }

});
